<!-- Used on Home Dashboard printing - Component for showing print version of memorial guide (non-interactive / all available plans) -->
<template>
	<div
		v-for="(plan, index) in plans"
		:key="plan.id"
		:class="index > 0 ? 'break-before-page' : ''"
	>
		<h2
			class="w-full pb-4 pl-6 text-3xl capitalize italic print:flex print:items-baseline print:justify-between print:border-b-3 print:border-slate-900 print:text-lg print:font-bold print:not-italic"
		>
			{{
				t(
					'plan.memorialGuideTitle',
					{ name: `${plan.firstName} ${plan.lastName}`.trim() },
					plan.firstName || plan.lastName ? 0 : 1
				)
			}}
			<PrintDate />
		</h2>

		<MemorialGuideForm
			:plan="plan"
			:index="index"
		/>
	</div>
</template>

<script setup lang="ts">
import type Plan from '@/classes/Plan'
import PrintDate from '@/components/common/PrintDate.vue'
import MemorialGuideForm from '@/components/memorialGuide/MemorialGuideForm.vue'
import { usePresentationLocale } from '@/i18n'
import type { PropType } from 'vue'

defineProps({
	plans: Array as PropType<Array<Plan>>,
})

const { t } = usePresentationLocale()
</script>
